import React from 'react';
import { roles } from '@nxsys/store/constants';
import Prospect from '../../../modules/prospect';

const ComingSoon = React.lazy(
  () => import('../../../modules/errorPages/ComingSoon'),
);

export const prospectsConfig = [
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/prospects',
    element: <Prospect />,
  },
  {
    permittedRole: [roles.admin, roles.employer, roles.agency],
    path: '/prospects/:activeTab',
    element: <ComingSoon />,
  },
];
